import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  constructor(private toastr: ToastrService) { }

  showSuccess(message: string) {
    this.toastr.success(message, 'Sucesso!', {positionClass: 'toast-top-right', timeOut: 5000});
  }

  showWarning(message: string) {
    this.toastr.warning(message, 'Atenção!', {positionClass: 'toast-top-right', timeOut: 5000});
  }

  showError(message: string) {
    this.toastr.error(message, 'Erro', {positionClass: 'toast-top-right', timeOut: 5000});
  }
}
